var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cyber-auth-wrapper",attrs:{"id":"login-main"}},[_c('div',{staticClass:"cyber-grid"}),_c('div',{staticClass:"cyber-particles"},_vm._l((6),function(n){return _c('div',{key:n,staticClass:"particle",class:'p-' + n})}),0),_c('div',{staticClass:"cyber-auth-container"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }